<h1 mat-dialog-title class="select-case-title">
  Select Case
  <button mat-dialog-close type="button" class="close pull-right" (click)="cancel()" aria-label="Close">&times;</button>
</h1>
<hr>
<div mat-dialog-content class="select-case-content">
  <!-- Hearing date range lives above the grid (Job List style); Case Number / Case Profile / Court
       Room / Court Location / Case Status are per-column filters in the grid's header row, and the
       actions (Refresh / Reset Filters) are icon buttons in the grid toolbar. -->
  <div class="row">
    <div class="col-md-3">
      <label class="case-field-label">Hearing Date From</label>
      <jqxDateTimeInput [theme]="'material'" [width]="180" [height]="34" [formatString]="'dd-MMM-yyyy'"
        [showTimeButton]="false" [value]="hearingDateFromValue" [max]="fromMaxDate" (onValueChanged)="onHearingDateFromChanged($event)">
      </jqxDateTimeInput>
    </div>
    <div class="col-md-3">
      <label class="case-field-label">Hearing Date To</label>
      <jqxDateTimeInput [theme]="'material'" [width]="180" [height]="34" [formatString]="'dd-MMM-yyyy'"
        [showTimeButton]="false" [value]="hearingDateToValue" [min]="toMinDate" (onValueChanged)="onHearingDateToChanged($event)">
      </jqxDateTimeInput>
    </div>
  </div>

  <div class="table-responsive mt-2">
    <jqxGrid #selectCaseGrid aria-hidden="true" [source]="dataAdapter" [columns]="columns" [virtualmode]="true"
      [rendergridrows]="rendergridrows" [theme]="'material'" [width]="'99.9%'" [height]="360" [sortable]="true"
      [pageable]="true" [pagesize]="10" [pagesizeoptions]="['5','10','20']" [selectionmode]="'singlerow'"
      [localization]="gridLocalization" [autoshowloadelement]="true" [scrollbarsize]="6"
      [filterable]="true" [showfilterrow]="true" [keyboardnavigation]="false"
      [showtoolbar]="true" [toolbarheight]="42" [rendertoolbar]="renderGridToolbar"
      (onFilter)="onGridFilter($event)">
    </jqxGrid>
  </div>
</div>
<div mat-dialog-actions class="select-case-actions">
  <button class="btn btn-viq-secondary ml-2" (click)="cancel()">Cancel</button>
  <button class="btn btn-viq btn-viq-primary ml-2" (click)="onSelect()">Select</button>
</div>
<jqxNotification #msgNotification [position]="'top-right'" [opacity]="1.0" [autoOpen]="false" [autoClose]="true"
  [animationOpenDelay]="800" [autoCloseDelay]="5000" template.success>
</jqxNotification>
